// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-pages----styles-module---wrapper---3FO2S","canvas":"src-pages----styles-module---canvas---Eg4yy","controls":"src-pages----styles-module---controls---9X1bY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/styles.module.css
// module id = 367
// module chunks = 35783957827783